import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { costsReducer } from './Costs';
import { CostsSagasListener } from './Costs/sagas';

const sagaMiddleware = createSagaMiddleware();
const middleware = applyMiddleware(sagaMiddleware);

export const costsStoreReducer = combineReducers({
  costs: costsReducer,
});

export const costsStore = createStore(costsStoreReducer, compose(middleware));
[CostsSagasListener].forEach(sagaMiddleware.run);

export type CostsState = ReturnType<typeof costsStoreReducer>;
